const getters = {
  getLanguage(state) {
    return state.lang
  },
}
export default getters
